// extracted by mini-css-extract-plugin
module.exports = {"keyBorder":"keyTakeaway_keyBorder__54BMr","title":"keyTakeaway_title__iqqHF","lists":"keyTakeaway_lists__kIz08","keyTakeaways":"keyTakeaway_keyTakeaways__ABj2w"};